const ALL_VALUE = 'all'

export {
  ALL_VALUE
}
